import React, { useEffect, useRef } from 'react'

export type CheckboxProps = {
  id: string
  name: string
  value: string
  label?: string
  checked?: boolean
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  disabled?: boolean
  large?: boolean
  indeterminate?: boolean
  ariaLabelledBy?: string
  reference?: React.RefObject<HTMLInputElement>
  testId?: string
}

export const Checkbox = ({
  id,
  name,
  value,
  label,
  checked,
  onChange,
  disabled,
  large,
  indeterminate,
  ariaLabelledBy,
  reference,
  testId
}: CheckboxProps) => {
  const internalRef = useRef<HTMLInputElement>(null)
  const resolvedRef = reference ?? internalRef

  useEffect(() => {
    if (resolvedRef.current) {
      resolvedRef.current.indeterminate = indeterminate ?? false
    }
  }, [indeterminate, resolvedRef])

  return (
    <div
      className={`Checkbox${large ? ' Checkbox--large' : ''}`}
      aria-labelledby={ariaLabelledBy}
      data-testid={testId ? `${testId}-wrapper` : undefined}
    >
      <input
        className={`Checkbox-button${large ? ' Checkbox--large' : ''}`}
        id={id}
        name={name}
        type="checkbox"
        value={value}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        ref={resolvedRef}
        data-testid={testId ? `${testId}-input` : undefined}
      />
      <label
        htmlFor={id}
        className="Checkbox-label"
        data-testid={testId ? `${testId}-label` : undefined}
      >
        {label}
      </label>
    </div>
  )
}
